import { StyledCard, CardLabel, CardHeader, CardBtn } from "../styled";
import { StyledPriceInput } from "@/pages/utils/styled-input";
import { CustomSelector } from "@/pages/utils/styled-select";
import styled from "styled-components";
import arrow_up from "@/assets/images/arrow-up.png";
import arrow_down from "@/assets/images/arrow-down.png";
import arrow_right from "@/assets/images/arrow-right.png";
import { ContactsCombobox } from "@/components/contact/contacts-combobox";
import { capitalizeFirstLetter } from "@/utils/string-manipulation";

const StyledCardHeader = styled(CardHeader)`
  background-color: ${(props) => props.primary_color};
`;

const StyledCardBtn = styled(CardBtn)`
  background-color: ${(props) => props.primary_color};
`;

const Arrow = ({ direction }) => {
  const arrows = { up: arrow_up, down: arrow_down, right: arrow_right };
  return arrows[direction] ? (
    <img src={arrows[direction]} alt={`arrow-${direction}`} width="49px" height="49px" />
  ) : null;
};

const PaymentCard = ({
  customSelectValue,
  customSelectorSetValue,
  customSelectorSelectList,
  customSelectorPlaceholder,
  priceInputValue,
  priceInputSetValue,
  priceInputPlaceholder,
  cardTitle,
  primary_color,
  handleClick,
  arrowDirection,
  balance,
  moneyOut,
  buttonText,
}) => {
  const activeAccounts = (customSelectorSelectList || [])
    .filter((acc) => acc.payment_method_status === "active")
    .map((acc) => {
      const bankName =
        acc.payment_method_data?.institution?.name ||
        capitalizeFirstLetter(acc.payment_method_data?.account?.subtype);
      const accountType = acc.payment_method_data?.ach?.account_type;
      const last4 = acc.payment_method_data?.account?.mask;
      const accountString = `${bankName} - ${
        accountType?.charAt(0).toUpperCase() || ""
      }${accountType?.slice(1).toLowerCase() || ""} *${last4}`;
      return {
        label: accountString,
        value: { account_name: accountString, payment_method_id: acc?.payment_method_id },
      };
    });

  return (
    <StyledCard>
      <StyledCardHeader primary_color={primary_color} />
      <div className="p-22-26">
        <Arrow direction={arrowDirection} />
        <CardLabel>{cardTitle}</CardLabel>
        <CustomSelector
          bank
          value={customSelectValue}
          setValue={customSelectorSetValue}
          selectList={activeAccounts}
          width="100%"
          menuWidth={310}
          mBottom={14}
          placeholder={customSelectorPlaceholder}
          menuLeft
        />
        <StyledPriceInput
          value={priceInputValue}
          setValue={priceInputSetValue}
          placeholder={priceInputPlaceholder}
          width="100%"
          balance={balance}
          mBottom={14}
          moneyOut={moneyOut}
        />
        <StyledCardBtn onClick={handleClick} primary_color={primary_color}>
          {buttonText}
        </StyledCardBtn>
      </div>
    </StyledCard>
  );
};

const PaySomeoneCard = ({
  primary_color,
  selectedContact,
  setSelectedContact,
  selectedAccount,
  setSelectedAccount,
  handleClick,
}) => {
  const accounts = selectedContact?.contact_info?.accounts || [];

  const accountOptions = accounts.map((acc) => {
    const attrs = acc.attribute_values || acc;
    const label = `${attrs.bank_name} ${
      attrs.account_type?.charAt(0).toUpperCase() || ""
    }${attrs.account_type?.slice(1) || ""} **${attrs.account_num_last_4}`;
    return { label, value: attrs };
  });

  const matchedOption =
    accountOptions.find(
      (opt) => opt.value?.counter_party_id === selectedAccount?.counter_party_id
    ) || null;

  return (
    <StyledCard>
      <StyledCardHeader primary_color={primary_color} />
      <div className="p-22-26">
        <Arrow direction="right" />
        <CardLabel>Pay Someone from Your Pocketbook</CardLabel>
        <ContactsCombobox
          className="mb-4"
          requireEmail
          onSelect={(contact) => {
            setSelectedContact(contact);
            setSelectedAccount(null);
          }}
        />
        {selectedContact && accountOptions.length > 0 && (
          <CustomSelector
            bank
            value={matchedOption}
            setValue={(option) => setSelectedAccount(option?.value || null)}
            selectList={accountOptions}
            width="100%"
            menuWidth={310}
            mBottom={14}
            placeholder="Select account"
            menuLeft
          />
        )}
        <div className={!selectedContact ? "mt-[69px]" : null}>
          <StyledCardBtn onClick={handleClick} primary_color={primary_color}>
            Continue
          </StyledCardBtn>
        </div>
      </div>
    </StyledCard>
  );
};

export { PaymentCard, PaySomeoneCard };
